import { BASE_URL } from "../../data/BaseUrl";

export const fetchDefferedPayments = async (filters, TOKEN) => {
  let url = `payment/deferred`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchDefferedPayments=> ", error);
    throw error;
  }
};

export const fetchImportMembersPendingApproval = async (filters, TOKEN) => {
  let url = `member/import_approval_data`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchImportMembersPendingApproval=> ", error);
    throw error;
  }
};

export const fetchDefferedApprovals = async (filters, TOKEN) => {
  let url = `payment/couple-plan`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchDefferedApprovals=> ", error);
    throw error;
  }
};

export const fetchDiscountPaymentsRequests = async (filters, TOKEN) => {
  let url = `payment/deferred/custom_req`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchDiscountPaymentsRequests=> ", error);
    throw error;
  }
};

export const fetchPT_DiscountPaymentsRequests = async (filters, TOKEN) => {
  let url = `payment/pt_discount/approval_req`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchPT_DiscountPaymentsRequests=> ", error);
    throw error;
  }
};

export const fetchPT_DiscountPaymentLinks = async (filters, TOKEN) => {
  let url = `payment/pt_discount`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchPT_DiscountPaymentLinks=> ", error);
    throw error;
  }
};